@@ -0,0 +1,457 @@
<template>
    <div id="datatable">
        <v-data-table
            single-select
            :headers="headers"
            :items="currentPageItems"
            :page.sync="currentPage"
            :items-per-page="customPaginationPerPage"
            item-key="no"
            :single-expand="true"
            :expanded.sync="expanded"
            hide-default-footer
            show-expand
            :class="$attrs.customWidth ? 'width_control' : ''"
            loading-text="Loading... Please wait"
            @dblclick:row="selectRowAndFinish"
            @item-expanded="loadDetailExpanded"
            @click:row="rowClick"
            height="auto"
        >
            <!-- If headers have label item, trim the text-->
            <template v-slot:[`item.label`]="{ item }">
                <span>{{
                    item.label ? item.label.replace(/ /g, "&nbsp;") : item.label
                }}</span>
            </template>

            <!-- Regenerate no by index, because no used for redirect to detail -->
            <template v-slot:[`item.no`]="{ index }">
                {{ 10 * (currentPage - 1) + (index + 1) }}
            </template>

            <!-- If headers have is_restricted item, change to icon checkbox -->
            <template v-slot:[`item.is_restricted`]="{ item }">
                <v-icon v-if="!item.is_restricted" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <!-- If headers have is_home item, change to icon checkbox -->
            <template v-slot:[`item.is_home`]="{ item }">
                <v-icon v-if="!item.is_home" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <!-- If headers have is_live_class item, change to icon checkbox -->
            <template v-slot:[`item.is_live_class`]="{ item }">
                <v-icon v-if="!item.is_live_class" color="green3"
                    >mdi-checkbox-marked</v-icon
                >
                <v-icon v-else color="darkFade">mdi-close-box</v-icon>
            </template>

            <template v-slot:[`item.is_specific`]="{ item }">
                <div v-if="item.is_specific != null">
                    <v-icon v-if="item.is_specific" color="green3"
                        >mdi-checkbox-marked</v-icon
                    >
                    <v-icon v-else color="darkFade">mdi-close-box</v-icon>
                </div>
            </template>

            <template v-slot:expanded-item>
                <template v-if="routeMenu === 'transaksi'">
                    <td></td>
                    <td valign="top" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td valign="top" class="grey--text">Nama</td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.nama_siswa }}
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" class="grey--text">
                                    Order id
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.id }}
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" class="grey--text">No Hp</td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.handphone }}
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" class="grey--text">Sekolah</td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.school }}
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td colspan="2" valign="top" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td class="grey--text">Nama Group</td>
                                <td class="pl-2">{{ rowDetail.paket }}</td>
                            </tr>
                        </table>
                    </td>
                    <td valign="top" colspan="2" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    No. Rekening
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.payment_account }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    Bank
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.payment_company }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </template>

                <template v-if="routeMenu === 'konsul'">
                    <td valign="top" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td valign="top" class="grey--text">
                                    Student id
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.student_id }}
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" class="grey--text">Kelas</td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.id }}
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td valign="top" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td class="grey--text">Teacher id</td>
                                <td class="pl-2">{{ rowDetail.teacher_id }}</td>
                            </tr>
                        </table>
                    </td>
                    <td></td>
                    <td></td>
                    <td valign="top" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    Mulai
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ expanded_consule_start_time }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    Selesai
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ expanded_consule_end_time }}
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td valign="top" colspan="2" class="pa-3">
                        <table class="table-detail">
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    Sesi Terpakai
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.total_session || "-" }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    valign="top"
                                    class="grey--text"
                                    style="width: 90px"
                                >
                                    Tambah Sesi
                                </td>
                                <td valign="top" class="pl-2">
                                    {{ rowDetail.add_on || "-" }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </template>
            </template>

            <!-- <template v-if="routeMenu === 'konsul'" v-slot:expanded-item>
        <td></td>
        <td valign="top" class="pa-3" style="width: 210px">
          <table class="table-detail">
            <tr>
              <td valign="top" class="grey--text">Nama</td>
              <td valign="top" class="pl-2">{{ rowDetail.nama_siswa }}</td>
            </tr>
            <tr>
              <td valign="top" class="grey--text">Order id</td>
              <td valign="top" class="pl-2">{{ rowDetail.id }}</td>
            </tr>
            <tr>
              <td valign="top" class="grey--text">No Hp</td>
              <td valign="top" class="pl-2">{{ rowDetail.handphone }}</td>
            </tr>
            <tr>
              <td valign="top" class="grey--text">Sekolah</td>
              <td valign="top" class="pl-2">{{ rowDetail.school }}</td>
            </tr>
          </table>
        </td>
        <td colspan="2" valign="top" class="pa-3" style="width: 210px">
          <table class="table-detail">
            <tr>
              <td class="grey--text">Nama Group</td>
              <td class="pl-2">{{ rowDetail.paket }}</td>
            </tr>
          </table>
        </td>
        <td valign="top" colspan="2" class="pa-3" style="width: 210px">
          <table class="table-detail">
            <tr>
              <td valign="top" class="grey--text" style="width: 90px">
                No. Rekening
              </td>
              <td valign="top" class="pl-2">{{ rowDetail.payment_account }}</td>
            </tr>
            <tr>
              <td valign="top" class="grey--text" style="width: 90px">Bank</td>
              <td valign="top" class="pl-2">{{ rowDetail.payment_company }}</td>
            </tr>
          </table>
        </td>
      </template> -->

            <!-- If headers have is_home item, change to icon checkbox -->
            <template v-slot:[`item.status`]="{ item }">
                <v-btn
                    v-if="item.status === 'PENDING'"
                    small
                    depressed
                    rounded
                    color="#E8F5FA"
                    style="color: #3a89d3"
                >
                    Pending
                </v-btn>

                <v-btn
                    v-if="item.status === null"
                    small
                    depressed
                    rounded
                    color="#FFF3E0"
                    style="color: orange"
                >
                </v-btn>

                <v-btn
                    v-if="item.status === 'FAILED'"
                    small
                    depressed
                    rounded
                    color="#FFE5E5"
                    style="color: #ec675e"
                >
                    Failed
                </v-btn>

                <v-btn
                    v-if="item.status === 'SUCCESS'"
                    small
                    depressed
                    rounded
                    color="#EEFFE0"
                    style="color: #40bf75"
                >
                    Success
                </v-btn>

                <v-btn
                    v-if="item.status === 'finished'"
                    small
                    depressed
                    rounded
                    color="#EEFFE0"
                    style="color: #40bf75"
                >
                    Finished
                </v-btn>

                <v-btn
                    v-if="item.status === 'canceled'"
                    small
                    depressed
                    rounded
                    color="#FFE5E5"
                    style="color: #ec675e"
                >
                    Canceled
                </v-btn>

                <v-btn
                    v-if="item.status === 'timeout'"
                    small
                    depressed
                    rounded
                    color="#FFF3E0"
                    style="color: orange"
                >
                    Timeout
                </v-btn>

                <v-btn
                    v-if="item.status === 'started'"
                    small
                    depressed
                    rounded
                    color="#E8F5FA"
                    style="color: #3a89d3"
                >
                    Started
                </v-btn>
            </template>

            <!-- If headers have actions item, show headers aksi -->
            <template v-slot:[`item.actions`]="{ item }">
                <!-- Default if hasAction true, change to icon vertical three dots -->
                <v-menu offset-y v-if="hasAction">
                    <template v-slot:activator="{ on, attrs }">
                        <div icon v-bind="attrs" v-on="on">
                            <v-icon color="#4F4F4F" id="datatable_dot_btn">
                                mdi-dots-vertical
                            </v-icon>
                        </div>
                    </template>

                    <v-list>
                        <!-- Default detail if doesn't have hasPreviewSoal -->
                        <v-list-item
                            id="datatable_detail_btn"
                            class="test_cursor"
                            link
                            v-if="!hasPreviewSoal"
                            @click="selectRowAndFinish(item.no)"
                        >
                            <v-list-item-title>Detail</v-list-item-title>
                        </v-list-item>

                        <!-- If hasPreviewSoal true, changed detail (used for itembank) -->
                        <v-list-item
                            id="datatable_detail_btn"
                            class="test_cursor"
                            link
                            v-if="hasPreviewSoal"
                            @click="editItem(item.no)"
                        >
                            <v-list-item-title>Detail</v-list-item-title>
                        </v-list-item>

                        <!-- Delete button -->
                        <v-list-item
                            class="test_cursor"
                            v-if="$route.name != 'AmbisMeter'"
                            id="datatable_delete_btn"
                            link
                            @click="deleteItem(item.no)"
                        >
                            <v-list-item-title>Hapus</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="datatable_leaderboard_btn"
                            v-if="$route.name === 'AmbisMeter'"
                            class="test_cursor"
                            link
                            @click="toLeaderboard(item.no)"
                        >
                            <v-list-item-title>Leaderboard</v-list-item-title>
                        </v-list-item>

                        <!-- If hasPreview true, show preview button (used for MarkdownEditor-c) -->
                        <v-list-item
                            id="datatable_preview_btn"
                            v-if="hasPreview"
                            link
                            class="test_cursor"
                            :href="item.preview"
                            target="_blank"
                        >
                            <v-list-item-title>Preview</v-list-item-title>
                        </v-list-item>

                        <!-- If hasPreviewSoal true, show preview button (used for itembank) -->
                        <v-list-item
                            id="datatable_preview_soal_btn"
                            v-if="hasPreviewSoal"
                            link
                            class="test_cursor"
                            @click="previewItem(item.no)"
                        >
                            <v-list-item-title>Preview</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="open_new_tab_preview_soal_btn"
                            v-if="hasPreviewSoal"
                            link
                            class="test_cursor"
                            @click="openNewTab(item.no)"
                        >
                            <v-list-item-title>Open New Tab</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="open_new_tab_preview_soal_btn"
                            v-if="hasOpenNewTab"
                            link
                            class="test_cursor"
                            @click="openNewTab(item.no)"
                        >
                            <v-list-item-title>Open New Tab</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="open_new_tab_preview_soal_btn"
                            v-if="hasReview"
                            link
                            class="test_cursor"
                            @click="openReview(item.no)"
                        >
                            <v-list-item-title>Preview Soal</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <!-- </v-list> -->
                </v-menu>

                <!-- If hasActionn false && hasDetail true, just change to text button Ubah -->
                <v-btn
                    id="datatable_detail_btn"
                    v-if="hasDetail"
                    color="blew"
                    class="pa-0"
                    min-width="unset"
                    height="unset"
                    style="justify-content: unset !important"
                    text
                    @click="selectRowAndFinish(item.no)"
                >
                    Ubah
                </v-btn>

                <!-- If hasActionn false && hasDuplicate true, change to icon vertical three dots with Duplicate & Export Button -->
                <v-menu offset-y v-if="hasDuplicate">
                    <template v-slot:activator="{ on, attrs }">
                        <div icon v-bind="attrs" v-on="on">
                            <v-icon color="#4F4F4F" id="datatable_dot_btn">
                                mdi-dots-vertical
                            </v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-item
                            id="datatable_duplicate_btn"
                            class="test_cursor"
                            link
                            @click="duplicateItem(item.no)"
                        >
                            <v-list-item-title>Duplicate</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="datatable_export_btn"
                            class="test_cursor"
                            link
                            @click="exportItem(item.no)"
                        >
                            <v-list-item-title>Export</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="datatable_open_new_tab_btn"
                            class="test_cursor"
                            link
                            @click="openNewTab(item.no)"
                        >
                            <v-list-item-title>Open New Tab</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            id="open_new_tab_preview_soal_btn"
                            v-if="hasReview"
                            link
                            class="test_cursor"
                            @click="openReview(item.no)"
                        >
                            <v-list-item-title>Preview Soal</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <!-- If hasActionn false && hasDetail true, just change to text button Ubah -->
                <v-btn
                    v-if="hasDownload"
                    id="datatable_detail_btn"
                    depressed
                    small
                    class="pa-2"
                    height="33px"
                    color="#E8F5FA"
                    style="min-width: 0 !important"
                    @click="downloadFile(item)"
                >
                    <v-icon color="blew" style="font-size: 18px">
                        mdi-tray-arrow-down
                    </v-icon>
                </v-btn>
            </template>

            <template v-slot:top>
                <v-card-text class="py-0">
                    <v-container fluid>
                        <v-row class="mt-3">
                            <v-col cols="*">
                                <!-- Search input with filters by headers key -->
                                <v-text-field
                                    id="datatable_search"
                                    v-model="query"
                                    hide-details
                                    v-if="$route.name != 'UserGroupForm'"
                                    @keyup.enter="doFilter()"
                                    placeholder="Search"
                                    class="search_box"
                                    height="36px"
                                    outlined
                                >
                                    <template slot="append">
                                        <svg
                                            id="datatable_search_btn"
                                            class="test_cursor"
                                            v-if="
                                                !(
                                                    $store.state.datatable
                                                        .filter.value ||
                                                    $store.state.datatable
                                                        .filters.length > 0
                                                )
                                            "
                                            @click="doFilter()"
                                            width="40"
                                            height="40"
                                            viewBox="0 0 40 40"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                width="40"
                                                height="42"
                                                rx="10"
                                                fill="#868EA4"
                                            />
                                            <path
                                                d="M18 24C19.775 23.9996 21.4988 23.4054 22.897 22.312L27.293 26.708L28.707 25.294L24.311 20.898C25.405 19.4997 25.9996 17.7754 26 16C26 11.589 22.411 8 18 8C13.589 8 10 11.589 10 16C10 20.411 13.589 24 18 24ZM18 10C21.309 10 24 12.691 24 16C24 19.309 21.309 22 18 22C14.691 22 12 19.309 12 16C12 12.691 14.691 10 18 10Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M19.4121 14.5851C19.7911 14.9651 20.0001 15.4671 20.0001 15.9991H22.0001C22.001 15.4735 21.8977 14.953 21.6961 14.4676C21.4946 13.9822 21.1989 13.5415 20.8261 13.1711C19.3121 11.6591 16.6871 11.6591 15.1741 13.1711L16.5861 14.5871C17.3461 13.8291 18.6561 13.8311 19.4121 14.5851Z"
                                                fill="white"
                                            />
                                        </svg>
                                        <svg
                                            id="datatable_clear_search_btn"
                                            class="test_cursor"
                                            v-if="
                                                $store.state.datatable.filter
                                                    .value ||
                                                $store.state.datatable.filters
                                                    .length > 0
                                            "
                                            @click="clearFilter()"
                                            width="40"
                                            height="36"
                                            viewBox="0 0 40 36"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                width="40"
                                                height="36"
                                                rx="6"
                                                fill="#2690CB"
                                            />
                                            <path
                                                d="M21.4109 18.0002L25.7109 13.7102C25.8992 13.5219 26.005 13.2665 26.005 13.0002C26.005 12.7339 25.8992 12.4785 25.7109 12.2902C25.5226 12.1019 25.2672 11.9961 25.0009 11.9961C24.7346 11.9961 24.4792 12.1019 24.2909 12.2902L20.0009 16.5902L15.7109 12.2902C15.5226 12.1019 15.2672 11.9961 15.0009 11.9961C14.7346 11.9961 14.4792 12.1019 14.2909 12.2902C14.1026 12.4785 13.9968 12.7339 13.9968 13.0002C13.9968 13.2665 14.1026 13.5219 14.2909 13.7102L18.5909 18.0002L14.2909 22.2902C14.1972 22.3832 14.1228 22.4938 14.072 22.6156C14.0213 22.7375 13.9951 22.8682 13.9951 23.0002C13.9951 23.1322 14.0213 23.2629 14.072 23.3848C14.1228 23.5066 14.1972 23.6172 14.2909 23.7102C14.3839 23.8039 14.4945 23.8783 14.6163 23.9291C14.7382 23.9799 14.8689 24.006 15.0009 24.006C15.1329 24.006 15.2636 23.9799 15.3855 23.9291C15.5074 23.8783 15.618 23.8039 15.7109 23.7102L20.0009 19.4102L24.2909 23.7102C24.3839 23.8039 24.4945 23.8783 24.6163 23.9291C24.7382 23.9799 24.8689 24.006 25.0009 24.006C25.1329 24.006 25.2636 23.9799 25.3855 23.9291C25.5074 23.8783 25.618 23.8039 25.7109 23.7102C25.8046 23.6172 25.879 23.5066 25.9298 23.3848C25.9806 23.2629 26.0067 23.1322 26.0067 23.0002C26.0067 22.8682 25.9806 22.7375 25.9298 22.6156C25.879 22.4938 25.8046 22.3832 25.7109 22.2902L21.4109 18.0002Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </template>
                                    <template slot="prepend-inner">
                                        <div class="inside_search">
                                            <v-select
                                                id="datatable_search_filters"
                                                height="36px"
                                                style="
                                                    width: 104px;
                                                    display: inline-flex;
                                                "
                                                v-model="field"
                                                hide-details
                                                small
                                                placeholder="Filter"
                                                :items="headerKeys"
                                                item-text="text"
                                                item-value="value"
                                                outlined
                                                return-object
                                            ></v-select>
                                        </div>
                                    </template>
                                </v-text-field>
                            </v-col>

                            <!-- Sort by id feature -->
                            <!-- <v-col cols="2">
                <v-select
                  id="datatable_sort"
                  v-if="$route.name === 'VideoPembelajaran'"
                  v-model="orderBy"
                  height="36px"
                  hide-details
                  placeholder="Urutkan"
                  class="select_box"
                  outlined
                  :items="[{ text: 'Nomor Urut', value: 'desc' }]"
                  item-text="text"
                  item-value="value"
                  @change="updateOrderBy"
                ></v-select>
              </v-col> -->

                            <!-- Sort by id feature -->
                            <v-col cols="2">
                                <v-select
                                    id="datatable_sort"
                                    :disabled="
                                        $route.name === 'ItemBank' ||
                                        $route.name === 'Leaderboard'
                                    "
                                    v-if="$route.name != 'UserGroupForm'"
                                    v-model="orderBy"
                                    height="36px"
                                    hide-details
                                    placeholder="Urutkan"
                                    class="select_box"
                                    outlined
                                    :items="[
                                        { text: 'Baru ke Lama', value: 'desc' },
                                        { text: 'Lama ke Baru', value: 'asc' },
                                    ]"
                                    item-text="text"
                                    item-value="value"
                                    @change="updateOrderBy"
                                ></v-select>
                            </v-col>

                            <!-- Limit data shown feature -->
                            <!-- <v-col cols="2">
                <v-select
                  id="datatable_limit"
                  hide-details
                  height="36px"
                  v-model="pageSize"
                  class="select_box"
                  :items="[
                    { text: 'Row : 5', value: 5 },
                    { text: 'Row : 10', value: 10 },
                    { text: 'Row : 25', value: 25 },
                  ]"
                  disabled
                  item-text="text"
                  item-value="value"
                  outlined
                ></v-select>
              </v-col> -->
                        </v-row>

                        <!-- If hasMultiSearch true, show filter items (used for itembank) -->
                        <v-row class="my-3">
                            <v-col cols="*">
                                <v-chip
                                    color="blew"
                                    class="mt-4 mr-4"
                                    label
                                    dark
                                    small
                                    v-for="(filter, key) in $store.state
                                        .datatable.filters"
                                    :key="key"
                                    :id="'datatable_filter_' + key"
                                >
                                    <span class="pr-2">
                                        {{ filter.key.text }} =
                                        {{ filter.value }}
                                    </span>
                                    <v-icon small @click="delByOneFilter(key)">
                                        mdi-close-circle
                                    </v-icon>
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </template>
        </v-data-table>

        <!-- Default pagination if hasCustomPagination 0, shown total item '-' -->
        <div
            class="d-flex space-between pa-4"
            v-if="hasCustomPagination && customPaginationTotalPages === 0"
        >
            <span class="gray3--text">
                Menampilkan {{ items.length * currentPage }} dari -
            </span>
            <v-spacer />

            <!-- Pagination preview button -->
            <v-btn
                depressed
                class="pa-0"
                :disabled="currentPage == 1"
                @click="goToPage(--currentPage)"
                min-width="32px"
                height="32px"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <!-- Pagination current page -->
            <v-btn
                class="pa-0 mx-2"
                depressed
                dark
                color="blew"
                min-width="32px"
                height="32px"
            >
                {{ currentPage }}
            </v-btn>

            <!-- Pagination next button -->
            <v-btn
                depressed
                class="pa-0"
                min-width="32px"
                height="32px"
                :disabled="items.length < customPaginationPerPage"
                @click="goToPage(++currentPage)"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>

        <!-- If hasCustomPagination not 0, shown customPaginationTotalPages -->
        <div class="d-flex align-center space-between pa-4" v-else>
            <span class="gray3--text">
                Menampilkan
                {{ customPaginationPerPage * (currentPage - 1) + 1 }}
                sampai
                {{
                    customPaginationPerPage * currentPage > items.length
                        ? customPaginationTotalItems
                            ? customPaginationTotalItems
                            : customPaginationPerPage * (currentPage - 1) +
                              items.length
                        : customPaginationPerPage * currentPage
                }}
                dari
                {{
                    customPaginationTotalItems
                        ? customPaginationTotalItems + " entri"
                        : ` -`
                }}
            </span>
            <v-spacer />

            <!-- Pagination current page -->
            <v-pagination
                color="blew"
                @input="currentPage"
                v-model="currentPage"
                :length="maxPage"
                :total-visible="5"
            ></v-pagination>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "datatable",

    props: {
        items: { type: Array, default: [] },
        headers: { type: Array, default: [] },
        hasAction: { type: Boolean, default: false },
        hasDetail: { type: Boolean, default: false },
        hasExport: { type: Boolean, default: false },
        hasPreview: { type: Boolean, default: false },
        hasMultiSearch: { type: Boolean, default: false },
        hasPreviewSoal: { type: Boolean, default: false },
        hasPublish: { type: Boolean, default: false },
        hasDownload: { type: Boolean, default: false },
        hasPaymentStatus: { type: Boolean, default: false },
        hasOpenNewTab: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        hasReview: { type: Boolean, default: false },
        hasCustomPagination: { type: Boolean, default: false },
        hasCustomSearch: { type: Boolean, default: false },
        hasDuplicate: { type: Boolean, default: false },
        hasLeaderboard: { type: Boolean, default: false },
        hasEdit: { type: Boolean, default: false },
        persistFilter: { type: Boolean, default: true },
        currentPageProp: { type: Number, default: 1 },
        customPaginationCurrentPage: { type: Number, default: 1 },
        customPaginationPerPage: { type: Number, default: 0 },
        customPaginationTotalItems: { type: Number, default: 0 },
        customPaginationTotalPages: { type: Number, default: 0 },
        customPaginationSortMode: { type: String, default: "desc" },
        rowExpandedDetail: { type: Array, default: {} },
        routeMenu: { type: String, default: {} },
    },

    data: function () {
        return {
            currentPageItems: [],
            selectedRow: -1,
            filteredItems: [],
            headerKeys: [],
            query: null,
            orderBy: "desc",
            sorter: { text: "Baru ke Lama", value: true },
            field: 0,
            videoId: null,
            visibleRow: { text: "Row : 10", value: 10 },
            rowDetail: {},
            expanded: [],
        };
    },

    computed: {
        // not used
        player() {
            return this.$refs.youtube.player;
        },

        // set currentPage, if changed trigger goToPage to change data shown
        currentPage: {
            get: function () {
                if (this.hasCustomPagination) {
                    return this.customPaginationCurrentPage;
                }

                return parseInt(this.$store.state.datatable.currentPage);
            },

            set: function (val) {
                if (this.hasCustomPagination) {
                    this.goToPage(val);
                } else {
                    this.$store.commit("datatable_currentPage", val);
                }
            },
        },

        // not used
        pageStart: function () {
            return this.$store.state.datatable.pageStart;
        },

        // set pageSize, trigger data shown in one page
        pageSize: {
            get: function () {
                return (
                    this.customPaginationPerPage ||
                    this.$store.state.datatable.pageSize
                );
            },

            set: function (val) {
                this.currentPageItems = this.getItemsInPage(this.currentPage);
                this.customPaginationPerPage = val;
            },
        },

        // not used
        pageEnd: function () {
            return this.$store.state.datatable.pageEnd;
        },

        // set maxPage, if hasCustomPagination true set customPaginationTotalPages
        maxPage: function () {
            return this.hasCustomPagination
                ? this.customPaginationTotalPages
                    ? this.customPaginationTotalPages
                    : Math.ceil(this.customPaginationTotalItems / this.pageSize)
                : Math.ceil(this.filteredItems.length / this.pageSize);
        },

        // not used
        startNumber() {
            if (this.$route.name === "ItemBank") {
                return (this.currentPageProp - 1) * this.pageSize;
            } else {
                return (this.currentPage - 1) * this.pageSize;
            }
        },

        // not used
        filterCriteria: function () {
            var result = [];
            var filters = [];
            if (this.persistFilter)
                filters = this.$store.state.datatable.filters;

            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                var criteria = this.headers[filter.key] + " = " + filter.value;
                result.push(criteria);
            }

            return result;
        },

        expanded_consule_start_time: function () {
            return moment(this.rowDetail.start_time).format("HH:mm");
        },

        expanded_consule_end_time: function () {
            return moment(this.rowDetail.end_time).format("HH:mm");
        },
    },

    methods: {
        // Change sort by id
        updateOrderBy: function (order) {
            console.log(order);
            if (order) {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", order);
                else this.doOrder();
            } else {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", order);
                else this.doOrder();
            }
        },

        // Change data shown
        goToPage: function (page) {
            this.$emit("changePage", page);
        },

        // Not used
        publishing(item) {
            this.$emit("publishing", item);
        },

        // Not used
        unpublishing(item) {
            this.$emit("unpublishing", item);
        },

        // set pageSize, trigger data shown in one page
        getItemsInPage: function (page) {
            page = this.hasCustomPagination ? 1 : page;
            var start = (page - 1) * this.pageSize;
            var end = start + this.pageSize;

            if (end > this.filteredItems.length - 1) {
                return this.filteredItems.slice(start);
            }

            return this.filteredItems.slice(start, end);
        },

        // notify deleted data by givev no data (index = no data)
        deleteItem: function (index) {
            var selectedRow = this.selectRow(index);
            this.$emit("deleted", selectedRow);
        },

        // not used
        previewVideo: function (index) {
            if (index.url.indexOf("embed") > -1) {
                this.videoId = index.url.split("/")[4];
            } else {
                this.videoId = index.url.substring(index.url.indexOf("=") + 1);
            }
        },

        // give detail data choosen by no data
        selectRow: function (index) {
            var realIndex = index;
            this.selectedRow = index;

            var selectedRow = this.filteredItems.find(function (element) {
                return element.no == realIndex;
            });
            this.$emit("selected", selectedRow);

            return selectedRow;
        },

        // given no data to selectRow, and notify detail data to dblClicked
        selectRowAndFinish(index, data = null) {
            var selectedRow = this.selectRow(index);
            if (data) {
                selectedRow = this.selectRow(data.item.no);
            }
            this.$emit("dblClicked", selectedRow);
        },

        // notify duplicateClicked with detail data by no data (index = no data)
        duplicateItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("duplicateClicked", selectedRow);
        },

        // notify exportClicked with detail data by no data (index = no data)
        exportItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("exportClicked", selectedRow);
        },

        // open in new tab detail
        openNewTab(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("openNewTab", selectedRow);
        },

        // open review
        openReview(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("openReview", selectedRow);
        },

        // notify leaderboardClicked with detail data by no data (index = no data)
        toLeaderboard(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("leaderboardClicked", selectedRow);
        },

        // notify editNewTab with detail data by no data (index = no data)
        editItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("editNewTab", selectedRow);
        },

        // notify previewSoal with detail data by no data (index = no data)
        previewItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("previewSoal", selectedRow);
        },

        // default filter by headerKeys
        doFilter: function () {
            this.filteredItems = this.items;
            this.doOrder();
            if (this.field != null) {
                this.query = this.query !== null ? this.query.trim() : "";
                var criteria = { key: this.field, value: this.query };

                if (this.hasMultiSearch) {
                    // if hasMultiSearch true, store filters to datatable_push_filters and notify doSearch
                    var filters = this.$store.state.datatable.filters;
                    var sameField = filters.findIndex((v) => {
                        return this.field.value == v.key.value;
                    });

                    if (sameField == -1)
                        this.$store.commit("datatable_push_filters", criteria);
                    else filters[sameField].value = criteria.value;

                    this.query = null;
                    this.field = null;
                    this.$emit("doSearch", filters);
                } else if (this.hasCustomSearch) {
                    // if hasCustomSearch true, store filter to datatable_push_filter and notify doSearch
                    this.$store.commit("datatable_push_filter", criteria);
                    this.$emit("doSearch", criteria);
                } else {
                    // if hasCustomSearch true, trigger doBasicFilter to search manualy with all data given
                    this.$store.commit("datatable_push_filter", criteria);
                    var filter = this.$store.state.datatable.filter;
                    this.doBasicFilter(filter);
                }
            }
        },

        // search manually with all data given (just work with data not pagination)
        doBasicFilter: function (filter) {
            var result = this.items.filter(function (item) {
                if (!item[filter.key.value]) return false;
                var index = item[filter.key.value]
                    .toString()
                    .toLowerCase()
                    .indexOf(filter.value.toLowerCase());
                return index > -1;
            });

            this.filteredItems = result;
        },

        loadDetailExpanded(item) {
            this.$emit("loadDetailExpanded", item);
        },

        // remove all filters and goToPage 1
        clearFilter: function () {
            this.query = null;
            this.field = 0;
            this.filteredItems = this.items;
            this.$store.commit("datatable_pageStart", 1);
            this.$store.commit("datatable_pageEnd", 10);
            this.$store.commit("datatable_clear_filter");
            this.$store.commit("datatable_clear_filters");
            this.doOrder();

            if (this.hasCustomPagination)
                this.orderBy = this.customPaginationSortMode;
            else this.orderBy = this.$store.state.datatable.orderBy;
            if (!this.hasCustomSearch)
                this.$store.commit("datatable_clear_filters");
            if (this.hasCustomSearch) {
                // error double kalo hasCustomSearch = true; gara2 ini
                // |
                // V
                this.$emit("doSearch", {
                    value: null,
                    key: { text: null, value: null },
                });
                this.goToPage(1);
            }
        },

        // remove one filter on this.$store.state.datatable.filters
        delByOneFilter(keys) {
            var filters = this.$store.state.datatable.filters;
            this.$emit("deleteOnFilter", filters[keys]);
            this.$store.commit("datatable_delete_one_filters", keys);
        },

        // order all data given by id data
        doOrder: function () {
            var tmp = this.filteredItems.slice(0);
            this.filteredItems = [];
            if (this.orderBy == "asc") {
                tmp.sort(function (a, b) {
                    return a.id - b.id;
                });
            } else {
                tmp.sort(function (a, b) {
                    return b.id - a.id;
                });
            }

            this.filteredItems = tmp;
        },

        downloadFile(selectedRow) {
            this.$emit("downloadFile", selectedRow);
        },

        // not used
        playVideo() {
            this.player.playVideo();
        },

        // not used
        playing() {
            console.log("o/ we are watching!!!");
        },

        rowClick: function (item, row) {
            row.select(true);
        },
    },

    watch: {
        //not used
        // if currentPage changed trigger getItemsInPage to make sure data shown not max with pageSize (not used)
        currentPage: function (page) {
            this.expanded = [];
            this.currentPageItems = this.getItemsInPage(page);
        },

        // not used
        loading: function () {
            if (!this.loading) {
                setTimeout(() => {
                    this.updateOrderBy(this.orderBy);
                    this.doOrder();
                }, 500);
            }
        },

        // put all data items to filteredItems
        items: function (val) {
            this.filteredItems = val;
            var filters = this.$store.state.datatable.filter;
            if (filters.length > 0) {
                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    this.doBasicFilter(filter);
                }
            } else {
                this.doOrder();
            }
        },

        // not used
        filteredItems: function (val) {
            this.$store.commit("datatable_currentPage", 1);
            this.currentPageItems = this.getItemsInPage(this.currentPage);
        },

        // put value orderBy on this.sorter.value if orderBy changed
        orderBy: function (val) {
            if (val == "desc") {
                this.sorter.value = true;
            } else {
                this.sorter.value = false;
            }
            this.$store.commit("datatable_orderby", val);
        },

        // trigger updateOrderBy if sorter changed
        sorter: function (val) {
            this.updateOrderBy();
        },

        rowExpandedDetail: function (val) {
            this.rowDetail = val;
        },
    },

    mounted: function () {
        // make sure filter do not overlap when moving page
        this.$store.commit("datatable_clear_filter");
        this.$store.commit("datatable_clear_filters");
        this.filteredItems = this.items;
        this.currentPageItems = this.getItemsInPage(1);

        // regenerate headerKeys to remove actions
        this.headers.forEach((element, index) => {
            if (element.value != "actions") this.headerKeys.push(element);
        });

        //
        if (this.hasCustomPagination)
            this.orderBy = this.customPaginationSortMode;
        else this.orderBy = this.$store.state.datatable.orderBy;

        setTimeout(() => {
            // waiting this.filteredItems = this.items; so can order with filteredItems
            this.doOrder();
        }, 500);

        // make sure filter do not overlap when moving page
        if (this.$store.state.datatable.filter != {}) {
            (this.query = this.$store.state.datatable.filter.value),
                (this.field = this.$store.state.datatable.filter.key);
        }
    },
};
</script>

<style scoped>
.v-data-table >>> tr.v-data-table__selected {
    background: #bbdefb !important;
}

.search_box >>> .v-input__slot {
    min-height: 40px !important;
    padding: 0px !important;
}

.search_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.v-text-field--outlined >>> fieldset {
    border: 0 !important;
}

.search_box >>> .v-input__append-inner {
    margin: 0px !important;
}

.select_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.inside_search >>> .v-input__slot {
    padding-right: 12px !important;
    padding-left: 12px !important;
}

.inside_search >>> .v-input__control {
    background: #fbfbfb !important;
}

.inside_search >>> .v-input__append-inner {
    margin-bottom: 6px !important;
    margin-top: 6px !important;
}

.inside_search >>> .v-input {
    margin: 0px !important;
}

.width_control >>> td {
    max-width: 400px !important;
}

.normal .v-select.v-text-field input {
    min-width: 0 !important;
}

.search_box >>> input {
    min-width: 0 !important;
}

.v-input__slot {
    min-height: 40px !important;
    font-size: 14px !important;
}

.select_box >>> .v-input__control > .v-input__slot {
    min-height: 40px !important;
}

.table-detail tr td {
    padding-top: 3px;
    padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// DataTableDropdown.vue?81da12a2